// DESCRIPTION: Skeleton loading placeholders for grid and list
// layouts while events are being fetched.

const SkeletonCard = () => (
	<div className="nb-bg-white nb-rounded-xl nb-shadow-sm nb-border nb-border-gray-200 nb-overflow-hidden nb-animate-pulse">
		<div className="nb-h-48 nb-bg-slate-200" />
		<div className="nb-p-5">
			<div className="nb-h-5 nb-bg-slate-200 nb-rounded nb-w-3/4 nb-mb-3" />
			<div className="nb-h-4 nb-bg-slate-100 nb-rounded nb-w-1/2 nb-mb-2" />
			<div className="nb-h-4 nb-bg-slate-100 nb-rounded nb-w-2/3 nb-mb-4" />
			<div className="nb-h-3 nb-bg-slate-100 nb-rounded nb-w-full nb-mb-2" />
			<div className="nb-h-3 nb-bg-slate-100 nb-rounded nb-w-5/6 nb-mb-6" />
			<div className="nb-flex nb-gap-3">
				<div className="nb-h-9 nb-bg-slate-200 nb-rounded-lg nb-w-24" />
				<div className="nb-h-9 nb-bg-slate-200 nb-rounded-lg nb-w-24" />
			</div>
		</div>
	</div>
);

const SkeletonListItem = () => (
	<li className="nb-flex nb-flex-col nb-gap-10 nb-py-12 sm:nb-flex-row nb-animate-pulse">
		<div
			className="nb-w-52 nb-flex-none nb-rounded-2xl nb-bg-slate-200"
			style={ { aspectRatio: '4/5' } }
		/>
		<div className="nb-flex-auto nb-max-w-xl">
			<div className="nb-h-6 nb-bg-slate-200 nb-rounded nb-w-2/3 nb-mb-3" />
			<div className="nb-h-4 nb-bg-slate-100 nb-rounded nb-w-1/3 nb-mb-2" />
			<div className="nb-h-4 nb-bg-slate-100 nb-rounded nb-w-1/4 nb-mb-6" />
			<div className="nb-h-3 nb-bg-slate-100 nb-rounded nb-w-full nb-mb-2" />
			<div className="nb-h-3 nb-bg-slate-100 nb-rounded nb-w-5/6 nb-mb-2" />
			<div className="nb-h-3 nb-bg-slate-100 nb-rounded nb-w-4/6 nb-mb-6" />
			<div className="nb-flex nb-gap-4">
				<div className="nb-h-10 nb-bg-slate-200 nb-rounded-lg nb-w-28" />
				<div className="nb-h-10 nb-bg-slate-200 nb-rounded-lg nb-w-28" />
			</div>
		</div>
	</li>
);

const EventSkeleton = ( { layout = 'grid' } ) => {
	if ( layout === 'grid' ) {
		return (
			<div className="nb-grid nb-grid-cols-1 sm:nb-grid-cols-2 nb-gap-6">
				{ Array.from( { length: 6 } ).map( ( _, i ) => (
					<SkeletonCard key={ i } />
				) ) }
			</div>
		);
	}

	return (
		<ul role="list" className="nb-divide-y nb-divide-gray-200">
			{ Array.from( { length: 4 } ).map( ( _, i ) => (
				<SkeletonListItem key={ i } />
			) ) }
		</ul>
	);
};

export default EventSkeleton;
